export default {
  data() {
    return {
      userGroupId: null,
      allUsersNotInGroup: [],
      searchTitleNotInGroup: '',
      allUsersInGroup: [],
      searchTitleInGroup: '',
    };
  },
  methods: {
    addToGroup: function (data) {
      this.allUsersInGroup.push(data);
      for (let i = 0; i < this.allUsersNotInGroup.length; i++) {
        if (this.allUsersNotInGroup[i].id == data.id) {
          this.allUsersNotInGroup.splice(i, 1);
          break;
        }
      }
    },
    addAllList: function () {
      for (let i = 0; i < this.userGroupUsersNotInGroupFilteredList.length; i++) {
        this.allUsersInGroup.push(this.userGroupUsersNotInGroupFilteredList[i]);
        for (let j = 0; j < this.allUsersNotInGroup.length; j++) {
          if (this.allUsersNotInGroup[j].id == this.userGroupUsersNotInGroupFilteredList[i].id) {
            this.allUsersNotInGroup.splice(j, 1);
            i--;
            break;
          }
        }
      }
    },
    removeFromGroup: function (data) {
      this.allUsersNotInGroup.push(data);
      for (let i = 0; i < this.allUsersInGroup.length; i++) {
        if (this.allUsersInGroup[i].id == data.id) {
          this.allUsersInGroup.splice(i, 1);
          break;
        }
      }
    },
    removeAllList: function () {
      for (let i = 0; i < this.allUsersInGroup.length; i++) {
        this.allUsersNotInGroup.push(this.allUsersInGroup[i]);
      }
      this.allUsersInGroup = [];
    },
    backToUserGroupPage: function () {
      this.$router.push({ name: 'userGroup' });
    },
  },
};
